"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_news__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "news_hi_dark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Apps_ic_hi",
    "data-name": "Apps ic hi"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.62,
    y: 16,
    width: 110.77,
    height: 160,
    rx: 14.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_Box",
    "data-name": "Bounding Box",
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.059999998658895
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58,44.71h76a2.71,2.71,0,1,0,0-5.42H58a2.71,2.71,0,0,0,0,5.42Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,50H58a2.71,2.71,0,1,0,0,5.42h76A2.71,2.71,0,1,0,134,50Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,67.29H106a2.71,2.71,0,0,0,0,5.42h28a2.71,2.71,0,1,0,0-5.42Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,83.29H106a2.71,2.71,0,0,0,0,5.42h28a2.71,2.71,0,1,0,0-5.42Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,99.29H106a2.71,2.71,0,0,0,0,5.42h28a2.71,2.71,0,1,0,0-5.42Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,131.29H106a2.71,2.71,0,1,0,0,5.42h28a2.71,2.71,0,0,0,0-5.42Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,147.29H106a2.71,2.71,0,1,0,0,5.42h28a2.71,2.71,0,0,0,0-5.42Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,131.29H58a2.71,2.71,0,1,0,0,5.42H94a2.71,2.71,0,0,0,0-5.42Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,147.29H58a2.71,2.71,0,1,0,0,5.42H94a2.71,2.71,0,0,0,0-5.42Z",
    style: {
      fill: "#666"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,115.29H58a2.71,2.71,0,0,0,0,5.42h76a2.71,2.71,0,1,0,0-5.42Z",
    style: {
      fill: "#666"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M58,42h76a2.7,2.7,0,0,1,2.33,1.35,2.57,2.57,0,0,0,.38-1.35A2.73,2.73,0,0,0,134,39.29H58A2.73,2.73,0,0,0,55.29,42a2.67,2.67,0,0,0,.38,1.35A2.7,2.7,0,0,1,58,42Z",
    style: {
      fill: "#666",
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,52.71h76a2.7,2.7,0,0,1,2.33,1.35,2.57,2.57,0,0,0,.38-1.35A2.73,2.73,0,0,0,134,50H58a2.68,2.68,0,0,0-2.71,2.65,2.62,2.62,0,0,0,.38,1.41A2.7,2.7,0,0,1,58,52.71Z",
    style: {
      fill: "#666",
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,70h28a2.7,2.7,0,0,1,2.33,1.35,2.57,2.57,0,0,0,.38-1.35A2.73,2.73,0,0,0,134,67.29H106A2.73,2.73,0,0,0,103.29,70a2.67,2.67,0,0,0,.38,1.35A2.7,2.7,0,0,1,106,70Z",
    style: {
      fill: "#666",
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,86h28a2.7,2.7,0,0,1,2.33,1.35,2.57,2.57,0,0,0,.38-1.35A2.73,2.73,0,0,0,134,83.29H106A2.73,2.73,0,0,0,103.29,86a2.67,2.67,0,0,0,.38,1.35A2.7,2.7,0,0,1,106,86Z",
    style: {
      fill: "#666",
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,102h28a2.7,2.7,0,0,1,2.33,1.35,2.57,2.57,0,0,0,.38-1.35A2.73,2.73,0,0,0,134,99.29H106a2.73,2.73,0,0,0-2.71,2.71,2.67,2.67,0,0,0,.38,1.35A2.7,2.7,0,0,1,106,102Z",
    style: {
      fill: "#666",
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,134h28a2.7,2.7,0,0,1,2.33,1.35,2.57,2.57,0,0,0,.38-1.35,2.73,2.73,0,0,0-2.71-2.71H106a2.73,2.73,0,0,0-2.71,2.71,2.67,2.67,0,0,0,.38,1.35A2.7,2.7,0,0,1,106,134Z",
    style: {
      fill: "#666",
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,150h28a2.7,2.7,0,0,1,2.33,1.35,2.57,2.57,0,0,0,.38-1.35,2.73,2.73,0,0,0-2.71-2.71H106a2.73,2.73,0,0,0-2.71,2.71,2.67,2.67,0,0,0,.38,1.35A2.7,2.7,0,0,1,106,150Z",
    style: {
      fill: "#666",
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,134H94a2.7,2.7,0,0,1,2.33,1.35,2.57,2.57,0,0,0,.38-1.35A2.73,2.73,0,0,0,94,131.29H58A2.73,2.73,0,0,0,55.29,134a2.67,2.67,0,0,0,.38,1.35A2.7,2.7,0,0,1,58,134Z",
    style: {
      fill: "#666",
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,150H94a2.7,2.7,0,0,1,2.33,1.35,2.57,2.57,0,0,0,.38-1.35A2.73,2.73,0,0,0,94,147.29H58A2.73,2.73,0,0,0,55.29,150a2.67,2.67,0,0,0,.38,1.35A2.7,2.7,0,0,1,58,150Z",
    style: {
      fill: "#666",
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,118h76a2.7,2.7,0,0,1,2.33,1.35,2.57,2.57,0,0,0,.38-1.35,2.73,2.73,0,0,0-2.71-2.71H58A2.73,2.73,0,0,0,55.29,118a2.67,2.67,0,0,0,.38,1.35A2.7,2.7,0,0,1,58,118Z",
    style: {
      fill: "#666",
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.72,97.67V69.43a4.16,4.16,0,0,0-4.16-4.16H61.43a4.16,4.16,0,0,0-4.16,4.16h0V98.57a4.16,4.16,0,0,0,4.16,4.16H90.57a4.16,4.16,0,0,0,4.16-4.16V95.76",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: "2.82999992370606px",
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.45,89.74l3.14-3.14a2.05,2.05,0,0,1,2.9,0h0l9,9v-26a4.11,4.11,0,0,0-4.11-4.11H61.61A4.11,4.11,0,0,0,57.5,69.6h0v23l10.85-11a2,2,0,0,1,2.83-.07l.07.07h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59,86.6l-3.14,3.15-8.19-8.19a2.05,2.05,0,0,0-2.9,0h0L57.5,92.63v5.76a4.11,4.11,0,0,0,4.11,4.11H90.39a4.11,4.11,0,0,0,4.11-4.11h0V95.61l-9-9a2.06,2.06,0,0,0-2.91,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.28,
    cy: 73.72,
    r: 4.1,
    style: {
      fill: "#e60000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.28,77.16a4.09,4.09,0,0,1-4.08-3.77v.33a4.1,4.1,0,0,0,8.2,0,1.82,1.82,0,0,0,0-.33A4.1,4.1,0,0,1,86.28,77.16Z",
    style: {
      fill: "#666",
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9,102.21a4.1,4.1,0,0,0,2.6-3.82V95.61l-9-9a2,2,0,0,0-2.83-.08.6.6,0,0,0-.08.08l-3.14,3.14Z",
    style: {
      fill: "#666",
      opacity: 0.119999997317791,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.34,81.58l-10.84,11v5.76a4.11,4.11,0,0,0,4.11,4.11H90.39a4.1,4.1,0,0,0,1.51-.29L71.26,81.56a2.06,2.06,0,0,0-2.91,0Z",
    style: {
      fill: "#666",
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.39,102H61.61a4.11,4.11,0,0,1-4.11-4.11h0v.51a4.11,4.11,0,0,0,4.11,4.11H90.39A4.11,4.11,0,0,0,94.5,98.4h0v-.51A4.11,4.11,0,0,1,90.39,102Z",
    style: {
      fill: "#666",
      opacity: 0.059999998658895,
      isolation: "isolate"
    }
  })));
}

var _default = ic_news__dark;
exports.default = _default;